// extracted by mini-css-extract-plugin
export var borderRadius = "_fs-4";
export var large = "_fs-3";
export var logoContainer = "_fs-0";
export var nameLogo = "_fs-2";
export var small = "_fs-1";